import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TealiumConstants } from '@ddt-web/analytics';
import { Model } from '@ddt-web/data-service';
import { Memoize, ModelNameUtil } from '@ddt-web/generic-utils';
import { PortfolioIdUtil } from '@ddt-web/portfolio-data';
import * as get from 'lodash/get';

import { PillsFilterType } from './pills-filter-type.enum';

@Component({
	selector: 'mp-pills',
	templateUrl: './pills.component.html',
	styleUrls: ['./pills.component.scss']
})
export class PillsComponent {
	@Input() public selectedItems: any[] = []; // Currently supports ModelPortfolio or ModelsBrowseSelectedFilter type;
	@Input() public pillsFilterType: PillsFilterType;
	@Input() public tealiumDeselectAllText: string = TealiumConstants.MODELS_EXPERIENCE_EVENTS.PILL_DESELECT_ALL;
	@Output() public onChangePills: EventEmitter<any> = new EventEmitter<any>();

	/**
	 * Filter Items based on the input 'pillsFilterType'
	 */
	public getFilteredItems(): any[] {
		if (this.pillsFilterType === PillsFilterType.BLK) {
			return this.selectedItems.filter(model => PortfolioIdUtil.isBlackRockModel(get(model, 'id', '')) && model?.subType === 'BLK');
		} else if (this.pillsFilterType === PillsFilterType.CUSTOM) {
			return this.selectedItems.filter(model => PortfolioIdUtil.isBlackRockModel(get(model, 'id', '')) && model?.subType === 'CUSTOM');
		} else if (this.pillsFilterType === PillsFilterType.TPM) {
			return this.selectedItems.filter(model => PortfolioIdUtil.isThirdPartyModel(get(model, 'id', '')));
		} else if (this.pillsFilterType === PillsFilterType.NONE) {
			return this.selectedItems;
		} else {
			return [];
		}
	}

	/**
	 * Deselect all pills
	 */
	public deselectAll(): void {
		const itemsToDeselect = [...this.getFilteredItems()];
		itemsToDeselect.forEach(el => this.deselectItem(el, true));
	}

	/**
	 * Deselect specific pill based on the id
	 */
	public deselectItem(item: any, clearAll: boolean = false): void {
		const indexInShared = this.selectedItems.findIndex(selectedItem => get(selectedItem, 'id', '') === get(item, 'id'));
		// If item exists, remove it from 'selected'
		if (indexInShared !== -1) {
			const deletedItem = this.selectedItems.splice(indexInShared, 1);
			this.onChangePills.emit({ deselectAll: clearAll, deselectedItem: deletedItem, selectedItems: this.selectedItems });
		}
	}

	@Memoize()
	public getModelName(model: Model): string {
		return ModelNameUtil.getModelExternalName(model, model.name);
	}
}
